import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";

import useCustomBrokerPermission from "hooks/useCustomBrokerPermission";
import { useGetShipmentInvoices } from "api/queries/invoice/useGetShipmentInvoices";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import Button from "components/atoms/Button/Button";
import { PrimaryInvoiceLike, shouldShowFinalInvoicePrompt } from "helpers/hasSubmittedPrimaryInvoice";
import { ShipmentTrackingContext } from "pages/common/ShipmentTracking/ShipmentTrackingContext";
import "./ProviderTrackingPageAlerts.scss";
import Cookies from "js-cookie";
import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import { useGetTrackingReferences } from "api/queries/shipments/useGetTrackingReferences";

export default function ProviderTrackingPageAlerts() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setShowSubmitPodDialog } = useContext(ShipmentTrackingContext);

  const { data: trackingReferencesData } = useGetTrackingReferences(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const { data: shipmentBasicData }: any = useGetShipmentBasic(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const { data: shipmentDetails = {} } = useGetShipmentDetails(
    id || "",
    Cookies.get("is_guest") !== "true", // Don't update the notification setting if the user is a guest
    {
      enabled: !!id,
    },
  );

  const { request_status } = shipmentBasicData?.organization || {};

  const { data: invoices, isSuccess: invoicesReady } = useGetShipmentInvoices({
    shipmentId: id!,
    options: {
      enabled: !!id && request_status === "Delivered",
      select: (data: { results?: PrimaryInvoiceLike[] }) => data.results,
    },
  });

  const [isCustomBroker] = useCustomBrokerPermission();
  const isIncomplete = request_status === "Incomplete";
  const isDeliveredAndNeedsFinalInvoice =
    request_status === "Delivered" && shouldShowFinalInvoicePrompt(invoices, invoicesReady);
  const canSubmitWithoutTracking = trackingReferencesData?.tracking_settings?.can_submit_pod_without_tracking;

  if (Cookies.get("is_guest") === "true" || shipmentDetails?.viewing_as_guest_user) return null;
  return (
    <>
      {isIncomplete && canSubmitWithoutTracking && (
        <div className="provider-tracking-page-alert">
          <div className="font-b1">
            <FormattedMessage id="general.incompleteDelivery" defaultMessage="Incomplete Delivery" />
          </div>
          <Button onClick={() => setShowSubmitPodDialog(true)}>
            <FormattedMessage id="tracking.podSubmitPOD" defaultMessage="Submit POD" />
          </Button>
        </div>
      )}

      {isDeliveredAndNeedsFinalInvoice && !isCustomBroker && (
        <div className="provider-tracking-page-alert">
          <div className="font-b1">
            <FormattedMessage id="tracking.alerts.addInvoicePrompt" defaultMessage="Please submit the final invoice" />
          </div>
          <Button onClick={() => navigate(`/shipment/${id}/billing`)}>
            <FormattedMessage id="tracking.alerts.addInvoiceButton" defaultMessage="Submit invoice" />
          </Button>
        </div>
      )}
    </>
  );
}
